import {
    acceptedAttendeesLabelAndCount,
    tentativelyAcceptedAttendeesLabelAndCount,
    declinedAttendeesLabelAndCount,
    noResponseReceivedAttendeesLabelAndCount,
    twoAttendeeResponsesConcatenationFormat,
    threeAttendeeResponsesConcatenationFormat,
    fourAttendeeResponsesConcatenationFormat,
} from './getAttendeeResponseString.locstring.json';
import loc, { format } from 'owa-localize';
import AttendeeResponseCounts from '../schema/AttendeeResponseCountsInterface';

export default (attendeeResponseCounts: AttendeeResponseCounts): string => {
    const attendeeResponseOrder = [
        {
            responseKey: 'accepted',
            string: loc(acceptedAttendeesLabelAndCount),
        },
        {
            responseKey: 'tentative',
            string: loc(tentativelyAcceptedAttendeesLabelAndCount),
        },
        {
            responseKey: 'declined',
            string: loc(declinedAttendeesLabelAndCount),
        },
        {
            responseKey: 'noReponses',
            string: loc(noResponseReceivedAttendeesLabelAndCount),
        },
    ];

    let formattedAttendeeResponseString: string[] = [];

    attendeeResponseOrder.forEach(order => {
        if (attendeeResponseCounts[order.responseKey]) {
            formattedAttendeeResponseString.push(
                format(order.string, attendeeResponseCounts[order.responseKey])
            );
        }
    });

    switch (formattedAttendeeResponseString.length) {
        case 1:
            return formattedAttendeeResponseString[0];
        case 2:
            return format
                .bind(null, loc(twoAttendeeResponsesConcatenationFormat))
                .apply(null, formattedAttendeeResponseString);
        case 3:
            return format
                .bind(null, loc(threeAttendeeResponsesConcatenationFormat))
                .apply(null, formattedAttendeeResponseString);
        case 4:
            return format
                .bind(null, loc(fourAttendeeResponsesConcatenationFormat))
                .apply(null, formattedAttendeeResponseString);
        default:
            return null;
    }
};
